import { render } from "./VisualizedCurrency.vue?vue&type=template&id=2dbb1bb0&scoped=true"
import script from "./VisualizedCurrency.vue?vue&type=script&lang=js"
export * from "./VisualizedCurrency.vue?vue&type=script&lang=js"

import "./VisualizedCurrency.vue?vue&type=style&index=0&id=2dbb1bb0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbb1bb0"]])

export default __exports__